/**
 * @desc 已取消订单推送ARS
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(params: any, options?: any) {
  return updateResponse(
    http(URL + `/backdoor/cancelOrderToArs`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
